import { render } from "./goldFish.vue?vue&type=template&id=74e99420&scoped=true"
import script from "./goldFish.vue?vue&type=script&lang=js"
export * from "./goldFish.vue?vue&type=script&lang=js"

import "./goldFish.vue?vue&type=style&index=0&id=74e99420&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e99420"]])

export default __exports__